export default __webpack_public_path__ + "static/SUSHI-cab14b5de5853679d0d83d090b3ee475.jpg";